module.exports = __webpack_public_path__ + "img/icon_heart_off_brown.4fc10f59.svg";